import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

import { Observable, Subject, of } from 'rxjs';
import { map, takeUntil, pluck, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { LanguageService } from '@fcom/ui-translate';
import { CmsTemplateService } from '@fcom/cms/services';
import { CmsTemplate } from '@fcom/core-api';
import { LoyaltyRoutesPath } from '@fcom/loyalty-core/interfaces';
import { PageMetaService } from '@fcom/common/services';
import { setPageMetadata } from '@fcom/loyalty-core';
import { ProfileTier } from '@fcom/core-api/login';
import { profile } from '@fcom/core/selectors';
import { AppState } from '@fcom/core';

@Component({
  selector: 'fin-tier-progress-and-benefits',
  templateUrl: 'tier-progress-and-benefits.component.html',
  styleUrls: ['../../../loyalty-core/assets/styles/common.scss', './tier-progress-and-benefits.component.scss'],
})
export class TierProgressAndBenefitsComponent implements OnInit, OnDestroy, AfterViewInit {
  template$: Observable<CmsTemplate>;
  pageTitle$: Observable<string>;
  pageViewType$: Observable<string> = of('');
  showSideTitle$: Observable<boolean> = of(false);
  isEligible$: Observable<boolean>;

  private ngDestroyed$ = new Subject();

  constructor(
    private cmsTemplateService: CmsTemplateService,
    private languageService: LanguageService,
    private pageMetaService: PageMetaService,
    private store$: Store<AppState>
  ) {
    this.isEligible$ = this.store$.pipe(
      profile(),
      take(1),
      pluck('tier'),
      map((tier: ProfileTier): boolean => ![ProfileTier.JUNIOR, ProfileTier.BASIC, ProfileTier.SILVER].includes(tier))
    );
  }

  ngOnInit(): void {
    this.template$ = this.cmsTemplateService.load(
      `/${this.languageService.langValue}/${LoyaltyRoutesPath.PLUS}/${LoyaltyRoutesPath.TIER_PROGRESS_AND_BENEFITS}`
    );
    this.pageTitle$ = this.template$.pipe(map((template: CmsTemplate) => template?.header?.[0]?.title ?? ''));
  }

  ngAfterViewInit(): void {
    this.template$
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((template: CmsTemplate) => setPageMetadata(template, this.pageMetaService));
  }

  ngOnDestroy(): void {
    this.ngDestroyed$.next(true);
  }
}
